import { render, staticRenderFns } from "./SqlFormatter.vue?vue&type=template&id=9bcbe190&scoped=true"
import script from "./SqlFormatter.vue?vue&type=script&lang=js"
export * from "./SqlFormatter.vue?vue&type=script&lang=js"
import style0 from "./SqlFormatter.vue?vue&type=style&index=0&id=9bcbe190&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bcbe190",
  null
  
)

export default component.exports